module.exports = __webpack_public_path__ + "img/compensatoryHours.2ddaef5d.svg";